const actions = {
  SET_STATE: 'references/SET_STATE',
  LOAD: 'references/LOAD',
}

export default actions
